/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRtxProSyncCount: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvworkstation.GetRtxProSyncCountReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetRtxProSyncCount',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRtxProSyncBasicInfo: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetRtxProSyncBasicInfoParameters,
    Types.Nvapp.Nvworkstation.GetRtxProSyncBasicInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetRtxProSyncBasicInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRtxProSyncControlInfo: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetRtxProSyncControlInfoParameters,
    Types.Nvapp.Nvworkstation.GetRtxProSyncControlInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetRtxProSyncControlInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRtxProSyncStatusInfo: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetRtxProSyncStatusInfoParameters,
    Types.Nvapp.Nvworkstation.GetRtxProSyncStatusInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetRtxProSyncStatusInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRtxProSyncTopologyInfo: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetRtxProSyncTopologyInfoParameters,
    Types.Nvapp.Nvworkstation.GetRtxProSyncTopologyInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetRtxProSyncTopologyInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuConnectorInfo: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetGpuConnectorInfoParameters,
    Types.Nvapp.Nvworkstation.GetGpuConnectorInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetGpuConnectorInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuPciAddress: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetGpuPciAddressParameters,
    Types.Nvapp.Nvworkstation.GetGpuPciAddressReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetGpuPciAddress',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisplayTiming: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetDisplayTimingParameters,
    Types.Nvapp.Nvworkstation.GetDisplayTimingReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetDisplayTiming',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const WriteJsonDataToFile: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.WriteJsonDataToFileParameters,
    Types.Nvapp.Nvworkstation.WriteJsonDataToFileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'WriteJsonDataToFile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPciConnectivityType: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.GetPciConnectivityTypeParameters,
    Types.Nvapp.Nvworkstation.GetPciConnectivityTypeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'GetPciConnectivityType',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsForcedEdid: BridgeCommands.Command<
    Types.Nvapp.Nvworkstation.IsForcedEdidParameters,
    Types.Nvapp.Nvworkstation.IsForcedEdidReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvWorkstation',
    method: 'IsForcedEdid',
    persistent: false
};

export const Nvworkstation = {
GetRtxProSyncCount,
GetRtxProSyncBasicInfo,
GetRtxProSyncControlInfo,
GetRtxProSyncStatusInfo,
GetRtxProSyncTopologyInfo,
GetGpuConnectorInfo,
GetGpuPciAddress,
GetDisplayTiming,
WriteJsonDataToFile,
GetPciConnectivityType,
IsForcedEdid
};
